import { GRID_GEAR_WIDTH, type ColumnId } from '../lib/constants'

/** Left-to-right order of the grid columns; the store only decides visibility. Duration sits after
 * Finish (Freelo #32253593) — reading start/finish before their computed duration matches how the
 * client actually plans a task. */
export const COLUMN_ORDER: ColumnId[] = ['rowNumber', 'wbs', 'name', 'owner', 'start', 'finish', 'duration', 'predecessors', 'percent', 'float', 'health']

export const columnLabelKey: Record<ColumnId, string> = {
  rowNumber: 'Schedule_col_row',
  wbs: 'Schedule_col_wbs',
  name: 'Schedule_col_name',
  owner: 'Schedule_col_owner',
  duration: 'Schedule_col_duration',
  start: 'Schedule_col_start',
  finish: 'Schedule_col_finish',
  predecessors: 'Schedule_col_predecessors',
  percent: 'Schedule_col_percent',
  float: 'Schedule_col_float',
  health: 'Schedule_col_health',
}

/** Task 2 (Freelo #32253593): every column now has an explicit, user-resizable width stored in
 * `ganttStore.columnWidths` — this just reads it back out. */
export const columnWidth = (id: ColumnId, widths: Record<ColumnId, number>): number => widths[id]

/** The grid pane's width is derived, never stored: the sum of the currently visible columns' widths
 * plus the header's trailing gear cell (`GRID_GEAR_WIDTH`) — the body has no gear cell, but
 * reserving the same space keeps grid and header columns pixel-aligned. */
export const gridWidthFor = (visible: ColumnId[], widths: Record<ColumnId, number>): number =>
  visible.reduce((sum, c) => sum + widths[c], 0) + GRID_GEAR_WIDTH

/** Columns whose values are right-aligned numbers. */
export const isNumericColumn = (id: ColumnId): boolean => id === 'rowNumber' || id === 'percent' || id === 'float'
